// App.js
import { BrowserRouter, Route, Routes } from "react-router-dom";
import ScrollToTop from './ScrollToTop';
import { Suspense, lazy } from "react";

import Paymentconfirm from "./pages/paymentconfirm";
import Template from "./pages/Template";
import ProductWithCategory from "./pages/ProductCategory";
import ProductWithCategoryBrand from "./pages/ProductCategoryBrand";
import Products from "./pages/Products";
import ProductSingleCategory from "./pages/ProductSingleCategory";
import ProductSingleCategoryBrand from "./pages/ProductSingleCategoryBrand";
import SingleProductDetail from "./pages/SingleProductDetail";
import CartDetail from "./pages/CartDetail";
import ProductDelivery from "./pages/ProductDelivery";
import Login from "./pages/Login";
import Signup from "./pages/Signup";
import UpdateProfile from "./pages/UpdateProfile";
import View from "./view/Index";
import CheckOut from "./checkout/checkOut";
import Blog from "./blogs/blog";

import BlogDetail from "./blogs/BlogDetail";



import "react-phone-input-2/lib/style.css";
import "antd/dist/reset.css";
import About from "./otherpages/component/about";
import Explore from "./otherpages/component/explore";
import Passion from "./otherpages/component/passion";
import Agreement from "./otherpages/component/agreement";
import Story from "./otherpages/component/story";
import Policy from "./otherpages/component/policy";
import Solution from "./otherpages/component/solution";
import LocalBusinessSchema  from "./otherpages/component/LocalBusinessSchema";
import MyAccount from "./pages/MyAccount";
import Invoice from "./pages/Invoice";
import WorkOrderPage from "./pages/workorderpage";
import Chatbox from "./components/React+Plain"
import Orderplaced from "./pages/orderplaced";

import { ColorProvider } from "./view/context/ColorContext";
import Home from "./pages/Home";
import NotFound from "./pages/NotFound";


function App() {
  return (
    <BrowserRouter>
          <ScrollToTop />
    <ColorProvider>
    <Chatbox/>

    <Suspense fallback={<div>Loading...</div>}>

      <Routes>
        <Route path="/" element={<Home />} />
        <Route path="products" element={<Products />} />
        <Route path="products/:category/:id" element={<ProductWithCategory />} />
        <Route
          path="products/:category/:id/:subcategory/:id"
          element={<ProductSingleCategory />}
        />
        <Route
          path="products/:category/:id/:subcategory/:id/:name/:id"
          element={<SingleProductDetail />}
        />
             <Route
          path=":name/:id"
          element={<SingleProductDetail />}
        />
        <Route path="designer" element={<View />} />
        <Route path="cart" element={<CartDetail />} />
        <Route path="checkout" element={<CheckOut />} />
        <Route path="blogs" element={<Blog />} />
        <Route path="/blogs/:id" element={<BlogDetail />} />
        <Route path="product-delivery" element={<ProductDelivery />} />
        <Route path="login" element={<Login />} />
        <Route path="signup" element={<Signup />} />
        <Route path="update-profile" element={<UpdateProfile />} />
        <Route path="/about" element={<About />} />
                <Route path="/explore" element={<Explore />} />
                <Route path="/passion" element={<Passion />} />
                <Route path="/agreement" element={<Agreement />} />
                <Route path="/story" element={<Story />} />
                <Route path="/policy" element={<Policy />} />
                <Route path="/solution" element={<Solution />} />
                <Route path="/accounts" element={<MyAccount />} />
                <Route path="invoice" element={<Invoice/>}/>
                <Route path="workorderpage" element={<WorkOrderPage/>}/>
                <Route path="Orderplaced" element={<Orderplaced/>}/>
                     <Route path="*" element={<NotFound/>}/>
                     <Route path="/products/brand/:brandName" element={<ProductSingleCategoryBrand />} />
                     import SingleProductDetail from "./pages/SingleProductDetail";

                        <Route path="/products/brand/:brandName/:name/:id" element={<SingleProductDetail />} />

                              <Route path="/products/brand" element={<ProductWithCategoryBrand />} />



                
        {/* <Route path="/" element={<Template />} /> */}
      </Routes>
      </Suspense>

      </ColorProvider>
    </BrowserRouter>
  );
}

export default App;
